import {WavAudio} from "../helpers/recorder.ts";
import {uploadFile} from "./file.ts";
import axios from "axios";

export const transcribe = async (wavFile: WavAudio): Promise<string> => {
    const fileKey = await uploadFile('transcription-tasks', new File([wavFile.blob], 'transcription.wav', { type: 'audio/wav' }))

    const response = await axios.post('/api/transcribe', { fileKey });

    return response.data.text;
}

